import ModalUpdate from "../../Modal/ModalUpdate";

const StatusLimit = (props) => {
    return(
        <>
            <div className="bg-white rounded-xl">
                <div className="flex flex-row items-center py-[16px] px-[16px] justify-between">
                    <h3 className="text-black font-medium text-[20px]">Status Limit</h3>
                    <button onClick={props.reloadhandle}>
                        <img src={process.env.PUBLIC_URL+'/svg/reload-circle.svg'} alt="reload" className="w-[30px]"/>
                    </button>
                </div>
                <div className="overflow-auto pb-5">
                    <table className="text-left text-sm font-light min-w-full">
                        <thead className="bg-[#F9FAFB]">
                            <tr>
                                <th scope="col" class="px-4 py-4 whitespace-nowrap">STATUS LIMIT</th>
                                <th scope="col" class="px-4 py-4 whitespace-nowrap">LIMIT</th>
                                <th scope="col" class="px-4 py-4 whitespace-nowrap">CREATED DATE</th>
                                <th scope="col" class="px-4 py-4 whitespace-nowrap">CREATED BY</th>
                                <th scope="col" class="px-4 py-4 whitespace-nowrap">UPDATED DATE</th>
                                <th scope="col" class="px-4 py-4 whitespace-nowrap">UPDATED BY</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.datastatuslimit.map((result, key) => (
                                <tr className="border-y-2" key={key}>
                                    <td className="whitespace-nowrap px-4 py-4">{result.colmachinestatuslimitstatus}</td>
                                    <td className="whitespace-nowrap px-4 py-4">
                                        <div className="grid grid-cols-2 items-center justify-between">
                                            <div className="w-full">
                                                {result.colmachinestatuslimitlimit}
                                            </div>
                                            <div className="cursor-pointer w-full" onClick={() => props.modalupdatehandle(result)}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="whitespace-nowrap px-4 py-4">
                                        {new Date(result.colmachinestatuslimitcreatedatetime).toLocaleString("en-US", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                        })}
                                    </td>
                                    <td className="whitespace-nowrap px-4 py-4">{result.colmachinestatuslimitcreateusername}</td>
                                    <td className="whitespace-nowrap px-4 py-4">
                                        {new Date(result.colmachinestatuslimitlasteditdatetime).toLocaleString("en-US", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                        })}
                                    </td>
                                    <td className="whitespace-nowrap px-4 py-4">{result.colmachinestatuslimitlasteditusername}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ModalUpdate modal={props.modal} cancel={props.cancel} limitvalue={props.limitvalue} byvalue={props.byvalue} sendhandle={props.sendhandle}/>
        </>
    );
}

export default StatusLimit;